import React from "react";
import * as Ant from "antd";
import styled from "styled-components";
import { connect } from "react-redux";
import ActionCreator from "../ActionCreator";
import * as AppEvents from "../AppEvents";
import { Link } from "gatsby";
import * as Constants from "../constants";
import * as Theme from "../Theme";
import { GoogleLogin } from "react-google-login";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

const FacebookLogo =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAQAAAAAYLlVAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfhBwoKADWXdR8GAAAB7UlEQVRo3u2ZPUtcQRSGnzNYCKm8hQQLKyGkEhHZLcLWFmmSVNsFUmojFhbp/QE2FvkF619IsLDaZSFfkI8iRVYESZEriItI0GOxitndSbx3ZrxjMW85d957njNzZ+YyR/hLmtGgTo0lHhBefbp0aLMnufW5NjXXKpRrczx4pq1Kgl+rpdkgslwN/Qdm72DQ/6d9FiQHA8B25eFhlu2buY+lJohm/GCq8vwHOmLO0IgWHqZoGOrRwgPUDbWoADXRkzvZ9YqqL6qBX/mHd3xln+OR9ie8svYPuqxOdUOn7Vz60m6ZCJh7j+fyvqzJBAv/lsXy4cMBvGFZfrsYwwAcsCYXbtYwAOvSd7WGANiVHXezP8A5qz52f4Av8i0uwCc/u/9G9Hm8SWfY4mmxVP0BbCPwmhdF7f6H0UP5NZK/cMBMZQAioy06yWlxf7izwFEJoPwqeMb3W3qc8djq2wwD8FNuARC1IeqhvXf0KUgACSABRAcovxE9Gj4+5eNoBxXmLb5/XAKl4zgBJIAEkAASwD0AcL7dCaK+oRsVoGvoRAXoGNpRAdreJRuvH5Ij5ozkrETLf+WqhupTtBx/q04WtLZuLJn2KgfoDWqnBkByFvC4bnXQzqBuOkzuVLx2GIGh4vXQN+xSvi+xCqzl+0tKfT0KspeCNQAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxNy0wNy0xMFQxMDowMDo1MyswMjowMJw2HIMAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTctMDctMTBUMTA6MDA6NTMrMDI6MDDta6Q/AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAABJRU5ErkJggg==";
const GoogleLogo =
  "data:image/png;base64,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";

class LoginModal extends React.Component {
  constructor(props) {
    super(props);
    this.defaultValues = {
      identity: "admin",
      password: "Revtel123",
    };

    this.state = {
      open: false,
      loading: false,
      error: null,
      values: {
        ...this.defaultValues,
      },
    };

    this.sub = AppEvents.EvtShowLoginModal.subscribe(open => {
      this.setState({ open, values: { ...this.defaultValues }, error: null });
    });
  }

  componentWillUnmount() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  render() {
    const { open, values, loading, error } = this.state;

    return (
      <Ant.Modal
        visible={open}
        onCancel={() => this.setState({ open: false })}
        footer={
          <div style={{ display: "flex", justifyContent: "center" }}>
            還不是會員嗎？
            <Link to="/register">立刻註冊新帳號</Link>
          </div>
        }
        width="400px"
      >
        {error && <div style={{ color: "red" }}>{error}</div>}
        <div
          style={{
            display: "flex",
            alignItems: "stretch",
            flexDirection: "column",
          }}
        >
          <img
            src="/images/logo.png"
            width="150"
            style={{ marginBottom: 30, margin: "auto" }}
          />
          <Ant.Input
            id="login-identity-input"
            placeholder="信箱"
            value={values.identity}
            style={{ padding: 12, marginBottom: 10, marginTop: 30 }}
            onChange={e =>
              this.setState({ values: { ...values, identity: e.target.value } })
            }
          />

          {/* <label htmlFor="login-password-input">密碼</label> */}
          <Ant.Input
            id="login-password-input"
            placeholder="密碼"
            type="password"
            value={values.password}
            style={{ padding: 12 }}
            onChange={e =>
              this.setState({ values: { ...values, password: e.target.value } })
            }
          />
        </div>

        <BottomBar>
          <Ant.Button
            type="primary"
            loading={loading}
            onClick={this._handleLogin}
            color={Theme.colors.main}
            style={{ flex: 1, borderRadius: 5 }}
          >
            登入
          </Ant.Button>

          <div
            style={{ borderBottom: "0.5px solid #7b7979", margin: "20px 0px" }}
          ></div>
          <GoogleLogin
            clientId={Constants.googleClientId}
            buttonText="Login"
            render={renderProps => (
              <SocialSignInBtn
                css="background-color: #ffffff;"
                disabled={renderProps.disabled}
                onClick={renderProps.onClick}
              >
                <div style={{ flexBasis: 60, textAlign: "center" }}>
                  <img src={GoogleLogo} />
                </div>
                <div style={{ flex: 3, color: "#4a4a4a", marginLeft: 10 }}>
                  使用google帳號登入
                </div>
              </SocialSignInBtn>
            )}
            onSuccess={this._responseGoogle}
            onFailure={this._responseGoogle}
            cookiePolicy={"single_host_origin"}
          />

          <FacebookLogin
            appId={Constants.facebookClientId}
            callback={this._responseFacebook}
            render={renderProps => (
              <SocialSignInBtn
                css="background-color: #395899;"
                onClick={renderProps.onClick}
              >
                <div style={{ flexBasis: 60, textAlign: "center" }}>
                  <img src={FacebookLogo} />
                </div>
                <div style={{ flex: 3, color: "#ffffff", marginLeft: 10 }}>
                  使用facebook帳號登入
                </div>
              </SocialSignInBtn>
            )}
          />
        </BottomBar>

        {/* <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Ant.Button type="link" style={{ display: "block" }}>
            <Link to="/fgpass" style={{ fontSize: 12, color: "#9b9b9b" }}>
              忘記密碼？
            </Link>
          </Ant.Button>
        </div>

        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            style={{ flex: 1, height: 1, backgroundColor: "darkgray" }}
          ></div>
          <div style={{ margin: 10 }}>或</div>
          <div
            style={{ flex: 1, height: 1, backgroundColor: "darkgray" }}
          ></div>
        </div>

        <SocialSignInGroup>
          <SocialSignInBtn css="background-color: blue;">
            <a href={`${Constants.apiUrl}/auth/facebook`}>
              <img src={FacebookLogo} />
            </a>
          </SocialSignInBtn>

          <SocialSignInBtn>
            <a href={`${Constants.apiUrl}/auth/google`}>
              <img src={GoogleLogo} />
            </a>
          </SocialSignInBtn>
        </SocialSignInGroup> */}
      </Ant.Modal>
    );
  }

  _responseGoogle = async response => {
    let { appActions } = this.props;
    console.log(response);
    try {
      await appActions.googleLogin(response);
      await appActions.autoLogin();
      this.setState({ open: false });
    } catch (err) {
      console.log("error with google login", err);
    }
  };

  _responseFacebook = async response => {
    console.log(response);
    let { appActions } = this.props;
    console.log(response);
    try {
      await appActions.facebookLogin(response);
      await appActions.autoLogin();
      this.setState({ open: false });
    } catch (err) {
      console.log("error with facebook login", err);
    }
  };

  _handleLogin = async () => {
    const { identity, password } = this.state.values;

    if (!identity || !password) {
      return;
    }

    const { appActions } = this.props;

    this.setState({ loading: true });
    try {
      await appActions.login({ identity, password });
      this.setState({ open: false });
    } catch (ex) {
      console.warn("LoginModal ex", ex);
      this.setState({
        error:
          "Fail to login. Please confirm your identity and password, and retry again.",
      });
    }
    this.setState({ loading: false });
  };
}

const BottomBar = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const SocialSignInGroup = styled.div`
  display: flex;
  justify-content: center;
`;

const SocialSignInBtn = styled.div`
  cursor: pointer;
  display: block;
  width: 100%;
  height: 46px;
  border-radius: 5px;
  border: 1px solid #bdbdbd;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px 0px;

  & img {
    width: 28px;
    height: 28px;
  }

  ${props => props.css || ""}
`;

export default connect((state, ownProps) => ({}), ActionCreator, null, {
  forwardRef: true,
})(LoginModal);
